/** User-facing AI assistant branding (KAN-35). */
export const AI_NAME = "Z-Cars AI";

export const AI_POSSESSIVE = `${AI_NAME}'s`;
